enum EmailEntityType {
  PERSON = "contact",
  COMPANY = "account",
}

export default EmailEntityType;
